import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { TranslationKeys } from '../../../../translations';
import { ConfirmDialog } from '../../../../components';
import { EmployersTable } from './components/EmployersTable';
import { ConnectionsTable } from './components/ConnectionsTable';
import { ContainerStyled } from './RestoreConnectionsPage.styles';
import { useRestoreConnectionsPage } from './useRestoreConnectionsPage';

export const RestoreConnectionsPage = () => {
  const {
    selectedEmployer,
    connectionToRestore,
    employersSearchQuery,
    employersData,
    employersLoading,
    connectionsData,
    connectionsLoading,
    restoreLoading,
    employersPagination,
    connectionsPagination,
    handleEmployersSearchChange,
    handleSelectEmployer,
    handleBackToEmployers,
    handleRestoreClick,
    handleRestoreConfirm,
    handleRestoreCancel,
    handleEmployersPaginationChange,
    handleConnectionsPaginationChange,
  } = useRestoreConnectionsPage();

  return (
    <ContainerStyled>
      {/* Employers Section */}
      {!selectedEmployer && (
        <EmployersTable
          data={employersData?.data}
          loading={employersLoading}
          searchQuery={employersSearchQuery}
          onSearchChange={handleEmployersSearchChange}
          onSelectEmployer={handleSelectEmployer}
          pagination={employersPagination}
          onPaginationChange={handleEmployersPaginationChange}
        />
      )}

      {/* Deleted Connections Section */}
      {selectedEmployer && (
        <>
          <Box>
            <Button variant="text" startIcon={<ArrowBack />} onClick={handleBackToEmployers}>
              <FormattedMessage id={TranslationKeys.tools_restoreConnections_backToEmployers} />
            </Button>
          </Box>

          <ConnectionsTable
            data={connectionsData?.data}
            loading={connectionsLoading}
            onRestoreClick={handleRestoreClick}
            restoreLoading={restoreLoading}
            selectedEmployerName={selectedEmployer.employerName}
            pagination={connectionsPagination}
            onPaginationChange={handleConnectionsPaginationChange}
          />
        </>
      )}

      {/* Restore Confirmation Dialog */}
      <ConfirmDialog
        open={!!connectionToRestore}
        title={<FormattedMessage id={TranslationKeys.tools_restoreConnections_restoreConfirmTitle} />}
        onConfirm={handleRestoreConfirm}
        onClose={handleRestoreCancel}
      >
        <FormattedMessage
          id={TranslationKeys.tools_restoreConnections_restoreConfirmMessage}
          values={{ connectionName: connectionToRestore?.connectionName || '' }}
        />
      </ConfirmDialog>
    </ContainerStyled>
  );
};
